namespace CMS {

    interface AnalyticsEventData extends ng.IScope {
        type : string;
        name : string;
        properties : Object;
    }

    angular
        .module('cms')
        .directive('analyticsEvent', function(analytics) {
        return {
            scope: {
                type : '@',
                name : '@',
                properties : '='
            },
            link : function(scope : AnalyticsEventData) {
                analytics.track(scope.type, scope.name, scope.properties);
            }
        };
    });
}
